import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function TopChoice({choices}) {

  const [active, setActive] = useState();

  useEffect(() => {
  }, [active]);

  return (
    <div className="lg:pl-20 md:pl-10 pl-2">
      <div className="text-primary font-bold text-lg mt-12 mb-2">
        Top Choice
      </div>
      <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 ">
        {choices && choices.map((obj, k) => (
          <div
            key={k}
            className="md:w-[90%] w-[98%] md:h-[200px] h-[300px] mt-5"
            onMouseEnter={() => setActive(k)}
            onMouseLeave={() => setActive("")}
          >
            <img
              src={require(`./../../assets/${obj?.img[0]}`)}
              className={`${active === k ? "hidden" : ""} h-[100%] w-[100%]`}
              alt="alt"
            />
            <div
              className={`${
                active === k ? "block" : "hidden"
              } h-[100%] w-[100%] bg-red-500 rounded-2xl flex flex-col justify-between pb-5 text-white pt-5`}
            >
              <div className="flex justify-between items-center">
                <div className="bg-[#09AC5B]  rounded-r-3xl pt-2 pl-3 h-[32px] text-xs">
                  Popular
                </div>
                <div className="text-xs text-right">
                  RackRate
                  <div>
                    <del>{obj?.price}</del>
                  </div>
                </div>
                <div className="pr-2 text-xs text-right">
                  Our Offer<div>{obj?.price}</div>
                </div>
              </div>
              <div className="px-4 flex  flex-col items-between justify-between md:h-[75%] h-[80%] ">
                <div>
                  <p className="text-xs font-bold md:mt-3 mt-10"></p>
                  <p className="text-xs md:leading-0 leading-5 md:mt-1 mt-3">
                  {obj?.description}
                  </p>
                </div>
                <Link to="/banner" state={{choice:obj}} >
                  <button className="w-full text-xs bg-white text-primary rounded-full py-1 ">
                    Know More
                  </button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TopChoice;
